<template>
    <div class="DialogContentHistory__Component">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">היסטוריית שינויים - {{ fieldLabel }}</p>
                <button type="button" class="delete" @click="$emit('close')" />
            </header>
            <section class="modal-card-body">
                <div class="DialogContentHistory__Component__Loading">
                    <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false" />
                    
                    <div v-if="!isLoading && history.length === 0" class="no-history">
                        <p>אין היסטוריית שינויים עבור שדה זה</p>
                    </div>

                    <div v-if="!isLoading && history.length > 0" class="history-list">
                        <div v-for="item in history" :key="item.id" class="history-item">
                            <div class="history-header">
                                <div class="history-meta">
                                    <span class="history-date">{{ formatDate(item.changedDate) }}</span>
                                    <span class="history-user" v-if="item.changedByUserName">
                                        {{ item.changedByUserName }}
                                    </span>
                                </div>
                                <b-button 
                                    size="is-small"
                                    type="is-primary"
                                    @click="restoreVersion(item)"
                                    :loading="restoringId === item.id">
                                    שחזר גרסה זו
                                </b-button>
                            </div>
                            <div class="history-content">
                                <div class="content-preview" v-html="getPreview(item.fieldValue)"></div>
                                <b-button 
                                    size="is-small" 
                                    type="is-text"
                                    @click="toggleExpand(item.id)">
                                    {{ expandedId === item.id ? 'הצג פחות' : 'הצג יותר' }}
                                </b-button>
                                <div v-if="expandedId === item.id" class="content-full" v-html="item.fieldValue"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <b-button label="סגור" @click="$emit('close')" />
            </footer>
        </div>
    </div>
</template>

<script>
import { ToastProgrammatic as Toast } from "buefy";
import AdminService from "../services/AdminService";

export default {
    name: "DialogContentHistory",
    props: {
        isActive: {
            type: Boolean,
            default: false
        },
        courseId: {
            type: Number,
            required: true
        },
        fieldName: {
            type: String,
            required: true
        },
        fieldLabel: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isLoading: false,
            history: [],
            expandedId: null,
            restoringId: null
        };
    },
    watch: {
        isActive(newVal) {
            if (newVal) {
                this.loadHistory();
            }
        }
    },
    mounted() {
        if (this.isActive) {
            this.loadHistory();
        }
    },
    methods: {
        loadHistory() {
            this.isLoading = true;
            AdminService.getCourseContentHistory(this.courseId, this.fieldName)
                .then((response) => {
                    this.history = response.data;
                    console.log("history", this.history);
                })
                .catch(() => {
                    Toast.open({
                        type: "is-danger",
                        message: "שגיאה בטעינת היסטוריה",
                        duration: 4000,
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleString('he-IL', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            });
        },
        getPreview(content) {
            if (!content) return 'תוכן ריק';
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = content;
            const text = tempDiv.textContent || tempDiv.innerText || '';
            return text.length > 150 ? text.substring(0, 150) + '...' : text;
        },
        toggleExpand(id) {
            this.expandedId = this.expandedId === id ? null : id;
        },
        restoreVersion(item) {
            this.$buefy.dialog.confirm({
                title: 'שחזור גרסה',
                message: 'האם אתה בטוח שברצונך לשחזר גרסה זו? השינויים הנוכחיים יוחלפו. שינוי הגרסה יעבוד רק במצב של עריכה מתקדמת ! ',
                confirmText: 'שחזר',
                cancelText: 'בטל',
                type: 'is-warning',
                hasIcon: true,
                onConfirm: () => {
                    this.restoringId = item.id;
                    this.$emit('restore', {
                        fieldName: this.fieldName,
                        content: item.fieldValue
                    });
                    // Reset after a moment to allow parent to handle
                    setTimeout(() => {
                        this.restoringId = null;
                        this.$emit('close');
                    }, 500);
                }
            });
        }
    }
};
</script>

<style scoped lang="scss">
.DialogContentHistory__Component__Loading {
    position: relative;
    min-height: 200px;
}

.no-history {
    text-align: center;
    padding: 40px 20px;
    color: #999;
    font-size: 16px;
}

.history-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.history-item {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 15px;
    background-color: #fafafa;
}

.history-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e0e0e0;
}

.history-meta {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.history-date {
    font-weight: bold;
    color: #333;
    font-size: 14px;
}

.history-user {
    color: #666;
    font-size: 13px;
}

.history-content {
    .content-preview {
        padding: 10px;
        background-color: white;
        border: 1px solid #e8e8e8;
        border-radius: 3px;
        margin-bottom: 10px;
        font-size: 13px;
        color: #555;
        line-height: 1.5;
        white-space: pre-wrap;
    }

    .content-full {
        padding: 15px;
        background-color: white;
        border: 2px solid #d0d0d0;
        border-radius: 3px;
        margin-top: 10px;
        max-height: 400px;
        overflow: auto;
        
        ::v-deep {
            h1, h2, h3, h4, h5, h6 {
                margin: 10px 0;
            }
            
            p {
                margin: 8px 0;
            }
            
            a {
                color: #3273dc;
                text-decoration: underline;
            }
            
            div {
                margin: 5px 0;
            }
        }
    }
}
</style>

